import { Link, useParams, useNavigate } from "react-router-dom";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import { useState, useEffect } from "react";
import DeleteModal from "../../../components/deleteModal/DeleteModal";

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from "../../../components/basics/Preloading";

const SaleUnits = () => {
  const { branchId } = useParams();
  const [gridData, setGridData] = useState([]);
  const [showFormModal, setShowFormModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [isLogoUploading, setIsLogoUploading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    title: "",
    size: 20,
    part: 1,
    total: 0,
    parts: 0,
  });
  const [formModel, setFormModel] = useState({
    id: 0,
    title: "",
    imgSrc: "",
    logo: "",
    tels: "",
    description: "",
    branchId: branchId,
    createBy: "",
    createDate: "",
    modifyBy: "",
    modifyDate: "",
    snappSettings: "",
  });
  const navigate = useNavigate();

  const getGridData = async () => {
    const resp = await apiMethod.getUnits(
      filterModel.branchId,
      filterModel.size,
      filterModel.part,
      filterModel.title
    );
    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
    }
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getGridData();
      setLoading(false);
    };
    bindData();
  }, [branchId]);

  const validForm = () => {
    let errors = [];
    if (methods.isNullOrEmptyString(formModel.title)) {
      errors.push(".عنوان باید مقدار داشته باشد");
    }
    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  };

  const resetForm = () => {
    formModel.id = 0;
    formModel.title = "";
    formModel.imgSrc = "";
    formModel.logo = "";
    formModel.tels = "";
    formModel.description = "";
    formModel.branchId = branchId;
    formModel.createBy = "";
    formModel.createDate = "";
    formModel.modifyBy = "";
    formModel.modifyDate = "";
    formModel.snappSettings = "";
    setFormModel({ ...formModel });
    setShowFormModal(false);
  };

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.title = "";
    filterModel.size = 20;
    filterModel.part = 1;
    setFilterModel({ ...filterModel });
  };

  const editItem = async (id) => {
    setLoading(true);
    const resp = await apiMethod.getUnitInfo(id);
    if (!methods.showApiErrors(resp)) return false;

    formModel.id = resp.data.id;
    formModel.title = resp.data.title;
    formModel.imgSrc = resp.data.imgSrc;
    formModel.logo = resp.data.logo;
    formModel.tels = resp.data.tels;
    formModel.description = resp.data.description;
    formModel.branchId = resp.data.branchId;
    formModel.createBy = resp.data.createBy;
    formModel.createDate = resp.data.createDate;
    formModel.modifyBy = resp.data.modifyDate;
    formModel.snappSettings = resp.data.snappSettings;
    setFormModel({ ...formModel });
    setShowFormModal(true);
    setLoading(false);
  };

  const createNewItem = async (e) => {
    if (!validForm()) return false;

    setLoading(true);

    try {
      const resp = await apiMethod.createUnit(formModel);

      if (!methods.showApiErrors(resp)) return false;

      await getGridData();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowFormModal(false);
    }
  };

  const UploadFile = async (file, attributeName) => {
    try {
      const formData = new FormData();
      formData.append("File", file);
      formData.append("FileType", 1);

      // Check if the attribute name is "imgSrc" or "logo" and append the corresponding value to the FormData
      const attributeValue = formModel[attributeName];
      if (typeof attributeValue === "string") {
        formData.append(attributeName, attributeValue);
      }
      const response = await apiMethod.uploadFile(formData);

      // Update branchData with the response data
      setFormModel((prevData) => ({
        ...prevData,
        [attributeName]: response.data,
      }));
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const changeImage = (fileOrEvent) => {
    let file;
    if (fileOrEvent instanceof File) {
      file = fileOrEvent;
    } else {
      file = fileOrEvent.target.files[0];
    }

    setFormModel((prevData) => ({
      ...prevData,
      imgSrc: file,
    }));
    setIsImageUploading(true);

    // Upload the file
    UploadFile(file, "imgSrc")
      .then(() => {
        // Stop the loading state when the file is uploaded
        setIsImageUploading(false);
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
      });
  };

  const changeLogo = (fileOrEvent) => {
    let file;
    if (fileOrEvent instanceof File) {
      file = fileOrEvent;
    } else {
      file = fileOrEvent.target.files[0];
    }

    setFormModel((prevData) => ({
      ...prevData,
      logo: file,
    }));
    setIsLogoUploading(true);

    // Upload the file
    UploadFile(file, "logo")
      .then(() => {
        // Stop the loading state when the file is uploaded
        setIsLogoUploading(false);
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
      });
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (filterModel.parts < filterModel.part + 1) {
        return false;
      }
      callPager(filterModel.part + 1);
    } else {
      if (filterModel.part === 1) {
        return false;
      }
      callPager(filterModel.part - 1);
    }
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= filterModel.parts; i++) {
      pages.push(
        <li
          key={i}
          className={
            filterModel.part === i ? "page-item active mx-1" : "page-item mx-1"
          }
        >
          <a
            className="page-link circular-pagination"
            onClick={() => {
              callPager(i);
            }}
          >
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  function downloadBase64AsBlob(base64Data, filename) {
    const [meta, base64] = base64Data.split(",");
    const mime = meta.match(/:(.*?);/)[1];

    const bytes = atob(base64);
    const array = new Uint8Array(bytes.length);

    for (let i = 0; i < bytes.length; i++) {
      array[i] = bytes.charCodeAt(i);
    }

    const blob = new Blob([array], { type: mime });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();

    URL.revokeObjectURL(url);
  }

  const downloadQrCode = async (item) => {
    setLoading(true);
    const resp = await apiMethod.getSalesUnitShopQrImage(item.id);
    setLoading(false);
    downloadBase64AsBlob(resp.data , item.title);
  };

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className="d-none d-lg-block">
              <Link
                to={`/sale/${branchId}/#4`}
                className="text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link to={`/sale/${branchId}/#4`} className="link back-link">
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                بخش های فروش شعبه
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>
                بخش های فروش شعبه
                <a
                  href={`/sale/${branchId}/softwareGuide/#section5`}
                  className="link rtlicon me-1"
                  title="برای اطلاعات بیشتر کلیک کنید"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain">
              <div className="salesearchsection">
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-4">
                    <label htmlFor="funit" className="form-label">
                      عنوان
                    </label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: "rtl", textAlign: "right" }}
                        value={filterModel.title}
                        onChange={(e) => {
                          setFilterModel({
                            ...filterModel,
                            title: e.target.value,
                            part: 1,
                          });
                        }}
                      />
                      <button
                        type="button"
                        className="btn btn-purple me-1"
                        onClick={searchItem}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-info"
                        onClick={clearSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                  <div className="col-12 col-md-2 col-lg-4"></div>
                  <div className="col-12 col-md-4 col-lg-4">
                    <div className="createButton">
                      <button
                        onClick={() => {
                          openNewForm();
                        }}
                        className="btn btn-outline-purple custome-btn"
                        type="button"
                      >
                        <span className="align-middle d-inline-block">
                          بخش جدید
                        </span>{" "}
                        <i className="bi bi-plus-circle align-middle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-responsive saletable">
                <table className="table table-striped table-md ">
                  <thead className="align-middle">
                    <tr>
                      <th scope="col vertical-center" width="20px">
                        ردیف
                      </th>
                      <th scope="col vertical-center">عنوان</th>
                      <th scope="col vertical-center">شماره شناسه</th>
                      <th scope="col vertical-center">شماره تماس</th>
                      <th scope="col vertical-center">توضیحات</th>
                      <th scope="col vertical-center">دریافت QR کد</th>
                      <th scope="col vertical-center">تنظیمات اسنپ</th>
                      <th scope="col vertical-center" width="100px">
                        عملیات
                      </th>
                    </tr>
                  </thead>
                  <tbody className="align-middle">
                    {gridData.map((unit, index) => (
                      <tr key={unit.id}>
                        <th scope="row">{index + 1}</th>
                        <td>{unit.title}</td>
                        <td>{unit.id}</td>
                        <td>{unit.tels}</td>
                        <td>{unit.description}</td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-purple"
                            onClick={() => downloadQrCode(unit)}
                          >
                            دریافت QR کد
                          </button>
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-purple"
                            onClick={() =>
                              navigate(
                                `/sale/${branchId}/saleunits/snapSetting/${unit.id}`
                              )
                            }
                          >
                            تنظیمات اسنپ
                          </button>
                        </td>
                        <td>
                          <button
                            onClick={() => editItem(unit.id)}
                            className="btn btn-sm btn-outline-purple me-2"
                            type="button"
                          >
                            <i className="bi bi-pencil-square"></i>
                          </button>
                          <button
                            onClick={() => selectَItemToDelete(unit)}
                            className="btn btn-sm btn-outline-danger"
                            type="button"
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filterModel.parts > 1 && (
                  <nav aria-label="Page navigation example" className="mt-5">
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPart(false);
                          }}
                        >
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {makePagerItems()}
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPart(true);
                          }}
                        >
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                )}
              </div>
            </div>
          </>
        }
      </>
    );
  };

  const openNewForm = async () => {
    resetForm();
    setShowFormModal(true);
  };

  const closeModal = () => {
    resetForm();
    setShowFormModal(false);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const selectَItemToDelete = (unit) => {
    setFormModel(unit);
    setShowDeleteModal(true);
  };

  const deleteItem = async (id) => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeUnit(formModel.id);
      if (!methods.showApiErrors(resp)) return false;

      await getGridData();
      resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const Modal = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: showFormModal ? "block" : "none" }}
      >
        <div className="modal-dialog  modal-md" role="document">
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title"> ایجاد / ویرایش بخش</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-md-12">
                  <label htmlFor="title" className="form-label required-label">
                    عنوان
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="title"
                    name="title"
                    value={formModel.title}
                    onChange={(e) => {
                      setFormModel({ ...formModel, title: e.target.value });
                    }}
                  />
                </div>
                <div className="col-md-12">
                  <label htmlFor="phone" className="form-label">
                    شماره های تماس
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="phone"
                    name="tels"
                    value={formModel.tels}
                    onChange={(e) => {
                      setFormModel({ ...formModel, tels: e.target.value });
                    }}
                  />
                </div>
                <div className="col-md-12">
                  <label htmlFor="description" className="form-label">
                    توضیحات
                  </label>
                  <textarea
                    type="text"
                    className="form-control"
                    id="description"
                    name="description"
                    value={formModel.description}
                    onChange={(e) => {
                      setFormModel({
                        ...formModel,
                        description: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="col-md-12 my-4">
                  <label htmlFor="fileUpload" className="form-label">
                    انتخاب تصویر(اندازه استاندارد 600 × 900است.)
                  </label>
                  <div
                    className="uploadfile"
                    onDragOver={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    onDrop={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      const file = e.dataTransfer.files[0];
                      changeImage(file);
                    }}
                  >
                    {!isImageUploading && (
                      <label htmlFor="imagefileInput">
                        {formModel.imgSrc
                          ? formModel.imgSrc
                          : "تصویر را بکشید اینجا بیاندازید"}
                        <input
                          type="file"
                          id="imagefileInput"
                          style={{ display: "none" }}
                          name="imagefileInput"
                          accept=".jpg, .jpeg, .png"
                          onChange={(e) => changeImage(e.target.files[0])}
                        />
                      </label>
                    )}
                    {isImageUploading && (
                      <div className="uploadfileloading form-control border-0">
                        <span
                          className="spinner-border spinner-border-sm"
                          aria-hidden="true"
                        ></span>
                        <span role="status"> در حال بارگذاری ... </span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-12 my-4">
                  <label htmlFor="fileUpload" className="form-label">
                    انتخاب لوگو(اندازه استاندارد 600 × 600 است.){" "}
                  </label>
                  <div
                    className="uploadfile"
                    onDragOver={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    onDrop={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      const file = e.dataTransfer.files[0];
                      changeLogo(file);
                    }}
                  >
                    {!isLogoUploading && (
                      <label htmlFor="logofileInput">
                        {formModel.logo
                          ? formModel.logo
                          : "لوگو را بکشید اینجا بیاندازید"}
                        <input
                          type="file"
                          id="logofileInput"
                          style={{ display: "none" }}
                          name="logofileInput"
                          accept=".jpg, .jpeg, .png"
                          onChange={(e) => changeLogo(e.target.files[0])}
                        />
                      </label>
                    )}
                    {isLogoUploading && (
                      <div className="uploadfileloading form-control border-0">
                        <span
                          className="spinner-border spinner-border-sm"
                          aria-hidden="true"
                        ></span>
                        <span role="status"> در حال بارگذاری ... </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn custome-btn btn-link-purple"
                onClick={closeModal}
              >
                انصراف
              </button>
              {isImageUploading || isLogoUploading ? (
                <button
                  type="submit"
                  className="btn custome-btn btn-purple w-50"
                  disabled
                >
                  ثبت وذخیره
                </button>
              ) : (
                <button
                  type="submit"
                  className="btn custome-btn btn-purple w-50"
                  onClick={() => {
                    createNewItem();
                  }}
                >
                  ثبت وذخیره
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {renderItems()}
      {showFormModal && Modal()}
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeDeleteModal}
          deleteItem={deleteItem}
          text={"شعبه"}
        />
      )}
    </>
  );
};
export default SaleUnits;
